// extracted by mini-css-extract-plugin
export default {"action":"style_action__O6Fvk","key":"style_key__mhP5k"};